const StoreLocatorUtils = (() => {
  // private method(s)
  const _constructor = () => {
    // console.log('Config is running');
  };

  const _getFilterDictionary = () => {
    return {
      // STORE TYPE
      'glo™ Popup Store': {
        type: 'store_type',
        value: 'glo™ Popup Store',
      },
      Tabacchi: {
        type: 'store_type',
        value: 'Tabacchi',
      },

      // ACTIVITIES
      'Dispositivi Hilo': {
        type: 'activity',
        key: 'activity_type',
      },
      'Dispositivi Hyper': {
        type: 'activity',
        key: 'activity_type1',
      },
      Sostenibilità: {
        type: 'activity',
        key: 'activity_type2',
      },
      'Stick per Hilo': {
        type: 'activity',
        key: 'activity_type3',
      },
      'Stick per Hyper': {
        type: 'activity',
        key: 'activity_type4',
      },
      Assistenza: {
        type: 'activity',
        key: 'activity_type5',
      },
      'Distributori H24 Stick': {
        type: 'activity',
        key: 'activity_type6',
      },
    };
  };

  // const _getFilterDictionary = () => {		//unico filtro
  // 	const filter_dictionary={
  // 		"Rivendite glo™": "store_type",
  // 		"glo™ Popup Store": "store_type",
  // 		"Assistenza":"activity_type3",
  // 		"Sustainability":"activity_type1",
  // 		"Rivendite glo™ Hilo":"activity_type5"
  // 	}
  // 	return filter_dictionary;
  // }

  const _getActivityDictionary = () => {
    const activity_dictionary = {
      Dispositivi: 'activity_type',
      'NEO™ Stick': 'activity_type2',
      'Distributore NEO™ Stick': 'activity_type3',
      Assistenza: 'activity_type4',
    };
    return activity_dictionary;
  };

  const _getStoreDictionary = () => {
    const store_dictionary = {
      'glo™ Agent': 'glo™ Shop Agent',
      'NEO™ Availability': 'Neo availability',
      'glo™ Shop': 'glo™ Shop',
      'glo™ Popup Store': 'glo™™™™ Discovery store',
    };
    return store_dictionary;
  };

  const _loadStores = async (componentObject) => {
    const jsonPath = componentObject.productImagePath;

    const request = await fetch(jsonPath)
      .then((response) => response.json())
      .then(async (formResponse) => {
        if (formResponse) {
          const { steps } = formResponse;

          if (steps && steps.length > 0) {
            // Loop steps
            await Promise.all(
              steps.map(async (step) => {
                const { formBlocks } = step;

                if (formBlocks && formBlocks.length > 0) {
                  // Loop Rows
                  await Promise.all(
                    formBlocks.map(async (block, index) => {
                      const { $ref } = block;

                      if ($ref) {
                        await _loadBlockJSON($ref).then((blockResponse) => {
                          formBlocks[index] = blockResponse;
                        });
                      }
                    })
                  );
                }
              })
            );
          }

          componentObject.stores = formResponse;
        }

        return componentObject;
      })
      .catch((error) => {
        /* eslint-disable-next-line no-console */
        console.log('Request failed: ', error);
      });

    return componentObject.stores;
  };

  _constructor();

  // output/public
  return {
    loadStores: _loadStores,
    getActivityDictionary: _getActivityDictionary,
    getStoreDictionary: _getStoreDictionary,
    getFilterDictionary: _getFilterDictionary,
  };
})();
